import { Component } from '@angular/core';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import { amplifyFormFields } from '../core/auth/auth.config';

@Component({
  standalone: true,
  selector: 'default-login',
  imports: [AmplifyAuthenticatorModule],
  templateUrl: './travomate.login.component.html'
})
export default class TravomateLoginComponent {
  protected readonly amplifyFormFields = amplifyFormFields;
}
